import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../data/ColisContext';

export default function RequireAuth({ children }) {
  const { user, authBooting } = useApp();
  const location = useLocation();

  if (authBooting) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
